import InterestDaysInYear from "@/models/Products/InterestDaysInYear";

export default (daysInYear: InterestDaysInYear) => {
    let returnVal = "Undefined";
    switch (daysInYear) {
        case InterestDaysInYear.Actual365:
            returnVal = "365 Days"
            break;
        case InterestDaysInYear.Actual360:
            returnVal = "360 Days (30 Days Per Month)"
            break;
    }
    return returnVal;
}